module.exports = __webpack_public_path__ + "static/media/C.fe6a9663.png";